import { useCallback, useRef } from "react";
import { Button } from "@/components/ui/button";

type Props = {
  onFileSelected: (file: File) => void | Promise<void>;
};

export function TemplateUploader({ onFileSelected }: Props) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const onPick = useCallback(() => inputRef.current?.click(), []);

  return (
    <div className="flex flex-col gap-3">
      <div className="rounded-md border border-dashed p-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="font-medium">Upload .xlsx template</p>
            <p className="text-sm text-muted-foreground">
              We don’t upload it to a server in this MVP.
            </p>
          </div>
          <Button className="bg-primary-blue" type="button" onClick={onPick}>
            Choose file
          </Button>
        </div>
      </div>

      <input
        ref={inputRef}
        className="hidden"
        type="file"
        accept=".xlsx"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFileSelected(file);
          e.currentTarget.value = "";
        }}
      />
    </div>
  );
}
